export const gjtCountryDefault = [
  {
    value: -2,
    // label: '默认',
    label: 'remote.common.default',
    name: '默认',
    icon: '',
    prefix: '',
  }
]

// 全球国家
// supportPurchase  是否支持购买
// companyAddress   公司所在国
// isEuropeanUnion 是否欧盟
export const gjtGlobalCountry = [
  //   产品要求去掉全球，所以注释掉
  /*{
                    value: 999,
                    label: 'remote.common.gjtGlobalCountry.country-1',
                    name: 'Global',
                    icon: '',
                    prefix: '',
                  },*/
  {
    value: 0,
    label: 'remote.common.gjtGlobalCountry.country0',
    name: 'United Kingdom',
    supportPurchase: true,
    companyAddress: true,
    icon: 'country_UK',
    prefix: 'GB',
  },
  {
    value: 1,
    label: 'remote.common.gjtGlobalCountry.country1',
    name: 'France',
    supportPurchase: true,
    companyAddress: true,
    icon: 'country_France',
    prefix: 'FR',
    isEuropeanUnion: true
  },
  {
    value: 2,
    label: 'remote.common.gjtGlobalCountry.country2',
    name: 'Germany',
    supportPurchase: true,
    companyAddress: true,
    icon: 'country_Germany',
    prefix: 'DE',
    isEuropeanUnion: true
  },
  {
    value: 3,
    label: 'remote.common.gjtGlobalCountry.country3',
    name: 'Italy',
    supportPurchase: true,
    companyAddress: true,
    icon: 'country_Italy',
    prefix: 'IT',
    isEuropeanUnion: true
  },
  {
    value: 4,
    label: 'remote.common.gjtGlobalCountry.country4',
    name: 'Spain',
    supportPurchase: true,
    companyAddress: true,
    icon: 'country_Spain',
    prefix: 'ES',
    isEuropeanUnion: true
  },
  {
    value: 146,
    label: 'remote.common.gjtGlobalCountry.country5',
    name: 'Andorra',
    prefix: 'AD',
  },
  {
    value: 147,
    label: 'remote.common.gjtGlobalCountry.country6',
    name: 'Angola',
    prefix: 'AO',
  },
  {
    value: 401,
    label: 'remote.common.gjtGlobalCountry.country7',
    name: 'Anguilla',
    prefix: 'AI',
  },
  {
    value: 402,
    label: 'remote.common.gjtGlobalCountry.country8',
    name: 'Antarctica',
    prefix: 'AQ',
  },
  {
    value: 148,
    label: 'remote.common.gjtGlobalCountry.country9',
    name: 'Antigua and Barbuda',
    prefix: 'AG',
  },
  {
    value: 140,
    label: 'remote.common.gjtGlobalCountry.country10',
    name: 'Argentina',
    prefix: 'AR',
  },
  {
    value: 288,
    label: 'remote.common.gjtGlobalCountry.country11',
    name: 'Armenia',
    prefix: 'AM',
    supportPurchase: true
  },
  {
    value: 403,
    label: 'remote.common.gjtGlobalCountry.country12',
    name: 'Aruba',
    prefix: 'AW',
  },
  {
    value: 105,
    label: 'remote.common.gjtGlobalCountry.country13',
    name: 'Australia',
    prefix: 'AU',
    icon: 'country_Australia',
  },
  {
    value: 8,
    label: 'remote.common.gjtGlobalCountry.country14',
    name: 'Austria',
    icon: 'country_Austria',
    companyAddress: true,
    isEuropeanUnion: true,
    prefix: 'AT',
  },
  {
    value: 142,
    label: 'remote.common.gjtGlobalCountry.country15',
    name: 'Azerbaijan',
    prefix: 'AZ',
  },
  {
    value: 152,
    label: 'remote.common.gjtGlobalCountry.country16',
    name: 'Bahamas',
    prefix: 'BS',
  },
  {
    value: 155,
    label: 'remote.common.gjtGlobalCountry.country17',
    name: 'Bahrain',
    prefix: 'BH',
  },
  {
    value: 233,
    label: 'remote.common.gjtGlobalCountry.country18',
    name: 'Bangladesh',
    prefix: 'BD',
  },
  {
    value: 150,
    label: 'remote.common.gjtGlobalCountry.country19',
    name: 'Barbados',
    prefix: 'BB',
  },
  {
    value: 157,
    label: 'remote.common.gjtGlobalCountry.country20',
    name: 'Belarus',
    prefix: 'BY',
  },
  {
    value: 9,
    label: 'remote.common.gjtGlobalCountry.country21',
    name: 'Belgium',
    icon: 'country_Belgium',
    companyAddress: true,
    isEuropeanUnion: true,
    prefix: 'BE',
  },
  {
    value: 165,
    label: 'remote.common.gjtGlobalCountry.country22',
    name: 'Belize',
    prefix: 'BZ',
  },
  {
    value: 160,
    label: 'remote.common.gjtGlobalCountry.country23',
    name: 'Benin',
    prefix: 'BJ',
  },
  {
    value: 404,
    label: 'remote.common.gjtGlobalCountry.country24',
    name: 'Bermuda',
    prefix: 'BM',
  },
  {
    value: 167,
    label: 'remote.common.gjtGlobalCountry.country25',
    name: 'Bhutan',
    prefix: 'BT',
  },
  {
    value: 177,
    label: 'remote.common.gjtGlobalCountry.country26',
    name: 'Bolivia (Plurinational State of)',
    prefix: 'BO',
  },
  {
    value: 405,
    label: 'remote.common.gjtGlobalCountry.country27',
    name: 'Bonaire, Sint Eustatius and Saba',
    prefix: 'BQ',
  },
  {
    value: 164,
    label: 'remote.common.gjtGlobalCountry.country28',
    name: 'Bosnia and Herzegovina',
    prefix: 'BA',
  },
  {
    value: 166,
    label: 'remote.common.gjtGlobalCountry.country29',
    name: 'Botswana',
    prefix: 'BW',
  },
  {
    value: 406,
    label: 'remote.common.gjtGlobalCountry.country30',
    name: 'Bouvet Island',
    prefix: 'BV',
  },
  {
    value: 107,
    label: 'remote.common.gjtGlobalCountry.country31',
    name: 'Brazil',
    prefix: 'BR',
    icon: 'country_Brazilian',
  },
  {
    value: 407,
    label: 'remote.common.gjtGlobalCountry.country32',
    name: 'British Indian Ocean Territory',
    prefix: 'IO',
  },
  {
    value: 279,
    label: 'remote.common.gjtGlobalCountry.country33',
    name: 'Brunei Darussalam',
    prefix: 'BN',
  },
  {
    value: 25,
    label: 'remote.common.gjtGlobalCountry.country34',
    name: 'Bulgaria',
    companyAddress: true,
    prefix: 'BG',
    isEuropeanUnion: true,
    icon: 'country_Bulgaria',
  },
  {
    value: 168,
    label: 'remote.common.gjtGlobalCountry.country35',
    name: 'Burkina Faso',
    prefix: 'BF',
  },
  {
    value: 169,
    label: 'remote.common.gjtGlobalCountry.country36',
    name: 'Burundi',
    prefix: 'BI',
  },
  {
    value: 182,
    label: 'remote.common.gjtGlobalCountry.country37',
    name: 'Cabo Verde',
    prefix: 'CV',
  },
  {
    value: 118,
    label: 'remote.common.gjtGlobalCountry.country38',
    name: 'Cambodia',
    prefix: 'KH',
  },
  {
    value: 206,
    label: 'remote.common.gjtGlobalCountry.country39',
    name: 'Cameroon',
    prefix: 'CM',
  },
  {
    value: 106,
    label: 'remote.common.gjtGlobalCountry.country40',
    name: 'Canada',
    prefix: 'CA',
    icon: 'country_Canada',
  },
  {
    value: 408,
    label: 'remote.common.gjtGlobalCountry.country41',
    name: 'Cayman Islands',
    prefix: 'KY',
  },
  {
    value: 297,
    label: 'remote.common.gjtGlobalCountry.country42',
    name: 'Central African Republic',
    prefix: 'CF',
  },
  {
    value: 295,
    label: 'remote.common.gjtGlobalCountry.country43',
    name: 'Chad',
    prefix: 'TD',
  },
  {
    value: 296,
    label: 'remote.common.gjtGlobalCountry.country44',
    name: 'Chile',
    prefix: 'CL',
  },
  {
    value: 298,
    label: 'remote.common.gjtGlobalCountry.country45',
    name: 'China',
    prefix: 'CN',
  },
  {
    value: 409,
    label: 'remote.common.gjtGlobalCountry.country46',
    name: 'Christmas Island',
    prefix: 'CX',
  },
  {
    value: 410,
    label: 'remote.common.gjtGlobalCountry.country47',
    name: 'Cocos (Keeling) Islands',
    prefix: 'CC',
  },
  {
    value: 186,
    label: 'remote.common.gjtGlobalCountry.country48',
    name: 'Colombia',
    prefix: 'CO',
  },
  {
    value: 207,
    label: 'remote.common.gjtGlobalCountry.country49',
    name: 'Comoros',
    prefix: 'KM',
  },
  {
    value: 184,
    label: 'remote.common.gjtGlobalCountry.country50',
    name: 'Congo',
    prefix: 'CG',
  },
  {
    value: 185,
    label: 'remote.common.gjtGlobalCountry.country51',
    name: 'Congo (Democratic Republic of the)',
    prefix: 'CD',
  },
  {
    value: 211,
    label: 'remote.common.gjtGlobalCountry.country52',
    name: 'Cook Islands',
    prefix: 'CK',
  },
  {
    value: 187,
    label: 'remote.common.gjtGlobalCountry.country53',
    name: 'Costa Rica',
    prefix: 'CR',
  },
  {
    value: 208,
    label: 'remote.common.gjtGlobalCountry.country54',
    name: "Côte d'Ivoire",
    prefix: 'CI',
  },
  {
    value: 27,
    label: 'remote.common.gjtGlobalCountry.country55',
    name: 'Croatia',
    companyAddress: true,
    prefix: 'HR',
    isEuropeanUnion: true,
    icon: 'country_Croatia',
  },
  {
    value: 190,
    label: 'remote.common.gjtGlobalCountry.country56',
    name: 'Cuba',
    prefix: 'CU',
  },
  {
    value: 411,
    label: 'remote.common.gjtGlobalCountry.country57',
    name: 'Curaçao',
    prefix: 'CW',
  },
  {
    value: 26,
    label: 'remote.common.gjtGlobalCountry.country58',
    name: 'Cyprus',
    companyAddress: true,
    prefix: 'CY',
    isEuropeanUnion: true,
    icon: 'country_Cyprus',
  },
  {
    value: 6,
    label: 'remote.common.gjtGlobalCountry.country59',
    name: 'Czech Republic',
    companyAddress: true,
    icon: 'country_CzechRepublic',
    prefix: 'CZ',
    isEuropeanUnion: true
  },
  {
    value: 14,
    label: 'remote.common.gjtGlobalCountry.country60',
    name: 'Denmark',
    companyAddress: true,
    prefix: 'DK',
    isEuropeanUnion: true,
    icon: 'country_Denmark',
  },
  {
    value: 198,
    label: 'remote.common.gjtGlobalCountry.country61',
    name: 'Djibouti',
    prefix: 'DJ',
  },
  {
    value: 412,
    label: 'remote.common.gjtGlobalCountry.country62',
    name: 'Dominica',
    prefix: 'DM',
  },
  {
    value: 175,
    label: 'remote.common.gjtGlobalCountry.country63',
    name: 'Dominican Republic',
    prefix: 'DO',
  },
  {
    value: 178,
    label: 'remote.common.gjtGlobalCountry.country64',
    name: 'Ecuador',
    prefix: 'EC',
  },
  {
    value: 31,
    label: 'remote.common.gjtGlobalCountry.country65',
    name: 'Egypt',
    prefix: 'EG',
    icon: 'country_Egypt',
  },
  {
    value: 413,
    label: 'remote.common.gjtGlobalCountry.country66',
    name: 'El Salvador',
    prefix: 'SV',
  },
  {
    value: 414,
    label: 'remote.common.gjtGlobalCountry.country67',
    name: 'Equatorial Guinea',
    prefix: 'GQ',
  },
  {
    value: 179,
    label: 'remote.common.gjtGlobalCountry.country68',
    name: 'Eritrea',
    prefix: 'ER',
  },
  {
    value: 28,
    label: 'remote.common.gjtGlobalCountry.country69',
    name: 'Estonia',
    companyAddress: true,
    prefix: 'EE',
    isEuropeanUnion: true
  },
  {
    value: 143,
    label: 'remote.common.gjtGlobalCountry.country70',
    name: 'Ethiopia',
    prefix: 'ET',
  },
  {
    value: 415,
    label: 'remote.common.gjtGlobalCountry.country71',
    name: 'Falkland Islands (Malvinas)',
    prefix: 'FK',
  },
  {
    value: 416,
    label: 'remote.common.gjtGlobalCountry.country72',
    name: 'Faroe Islands',
    prefix: 'FO',
  },
  {
    value: 180,
    label: 'remote.common.gjtGlobalCountry.country73',
    name: 'Fiji',
    prefix: 'FJ',
  },
  {
    value: 13,
    label: 'remote.common.gjtGlobalCountry.country74',
    name: 'Finland',
    companyAddress: true,
    prefix: 'FI',
    isEuropeanUnion: true
  },
  {
    value: 417,
    label: 'remote.common.gjtGlobalCountry.country75',
    name: 'Åland Islands',
    prefix: 'AX',
  },
  {
    value: 418,
    label: 'remote.common.gjtGlobalCountry.country76',
    name: 'French Guiana',
    prefix: 'GF',
  },
  {
    value: 419,
    label: 'remote.common.gjtGlobalCountry.country77',
    name: 'French Polynesia',
    prefix: 'PF',
  },
  {
    value: 420,
    label: 'remote.common.gjtGlobalCountry.country78',
    name: 'French Southern Territories',
    prefix: 'TF',
  },
  {
    value: 203,
    label: 'remote.common.gjtGlobalCountry.country79',
    name: 'Gabon',
    prefix: 'GA',
  },
  {
    value: 183,
    label: 'remote.common.gjtGlobalCountry.country80',
    name: 'Gambia',
    prefix: 'GM',
  },
  {
    value: 189,
    label: 'remote.common.gjtGlobalCountry.country81',
    name: 'Georgia',
    prefix: 'GE',
  },
  {
    value: 137,
    label: 'remote.common.gjtGlobalCountry.country82',
    name: 'Albania',
    prefix: 'AL',
  },
  {
    value: 202,
    label: 'remote.common.gjtGlobalCountry.country83',
    name: 'Ghana',
    prefix: 'GH',
  },
  {
    value: 421,
    label: 'remote.common.gjtGlobalCountry.country84',
    name: 'Gibraltar',
    prefix: 'GI',
  },
  {
    value: 15,
    label: 'remote.common.gjtGlobalCountry.country85',
    name: 'Greece',
    companyAddress: true,
    prefix: 'GR',
    isEuropeanUnion: true
  },
  {
    value: 422,
    label: 'remote.common.gjtGlobalCountry.country86',
    name: 'Greenland',
    prefix: 'GL',
  },
  {
    value: 188,
    label: 'remote.common.gjtGlobalCountry.country87',
    name: 'Grenada',
    prefix: 'GD',
  },
  {
    value: 423,
    label: 'remote.common.gjtGlobalCountry.country88',
    name: 'Guadeloupe',
    prefix: 'GP',
  },
  {
    value: 424,
    label: 'remote.common.gjtGlobalCountry.country89',
    name: 'Guam',
    prefix: 'GU',
  },
  {
    value: 277,
    label: 'remote.common.gjtGlobalCountry.country90',
    name: 'Guatemala',
    prefix: 'GT',
  },
  {
    value: 425,
    label: 'remote.common.gjtGlobalCountry.country91',
    name: 'Guernsey',
    prefix: 'GG',
  },
  {
    value: 200,
    label: 'remote.common.gjtGlobalCountry.country92',
    name: 'Guinea',
    prefix: 'GN',
  },
  {
    value: 201,
    label: 'remote.common.gjtGlobalCountry.country93',
    name: 'Guinea-Bissau',
    prefix: 'GW',
  },
  {
    value: 191,
    label: 'remote.common.gjtGlobalCountry.country94',
    name: 'Guyana',
    prefix: 'GY',
  },
  {
    value: 193,
    label: 'remote.common.gjtGlobalCountry.country95',
    name: 'Haiti',
    prefix: 'HT',
  },
  {
    value: 426,
    label: 'remote.common.gjtGlobalCountry.country96',
    name: 'Heard Island and McDonald Islands',
    prefix: 'HM',
  },
  {
    value: 222,
    label: 'remote.common.gjtGlobalCountry.country97',
    name: 'HOLY SEE (VATICAN CITY STATE)',
    prefix: 'VA',
  },
  {
    value: 196,
    label: 'remote.common.gjtGlobalCountry.country98',
    name: 'Honduras',
    prefix: 'HN',
  },
  {
    value: 131,
    label: 'remote.common.gjtGlobalCountry.country99',
    name: 'Hong Kong',
    prefix: 'HK',
    icon: 'a-country_HongKong',
  },
  {
    value: 16,
    label: 'remote.common.gjtGlobalCountry.country100',
    name: 'Hungary',
    companyAddress: true,
    prefix: 'HU',
    isEuropeanUnion: true
  },
  {
    value: 163,
    label: 'remote.common.gjtGlobalCountry.country101',
    name: 'Iceland',
    prefix: 'IS',
  },
  {
    value: 104,
    label: 'remote.common.gjtGlobalCountry.country102',
    name: 'India',
    prefix: 'IN',
  },
  {
    value: 119,
    label: 'remote.common.gjtGlobalCountry.country103',
    name: 'Indonesia',
    prefix: 'ID',
  },
  {
    value: 291,
    label: 'remote.common.gjtGlobalCountry.country104',
    name: 'Iran (Islamic Republic of)',
    prefix: 'IR',
  },
  {
    value: 290,
    label: 'remote.common.gjtGlobalCountry.country105',
    name: 'Iraq',
    prefix: 'IQ',
  },
  {
    value: 17,
    label: 'remote.common.gjtGlobalCountry.country106',
    name: 'Ireland',
    companyAddress: true,
    prefix: 'IE',
    isEuropeanUnion: true,
    icon: 'country_Ireland',
  },
  {
    value: 427,
    label: 'remote.common.gjtGlobalCountry.country107',
    name: 'Isle of Man',
    prefix: 'IM',
  },
  {
    value: 292,
    label: 'remote.common.gjtGlobalCountry.country108',
    name: 'Israel',
    prefix: 'IL',
  },
  {
    value: 138,
    label: 'remote.common.gjtGlobalCountry.country109',
    name: 'Algeria',
    prefix: 'DZ',
  },
  {
    value: 287,
    label: 'remote.common.gjtGlobalCountry.country110',
    name: 'Jamaica',
    prefix: 'JM',
  },
  {
    value: 100,
    label: 'remote.common.gjtGlobalCountry.country111',
    name: 'Japan',
    prefix: 'JP',
    icon: 'riben',
    companyAddress: true
  },
  {
    value: 428,
    label: 'remote.common.gjtGlobalCountry.country112',
    name: 'Jersey',
    prefix: 'JE',
  },
  {
    value: 293,
    label: 'remote.common.gjtGlobalCountry.country113',
    name: 'Jordan',
    prefix: 'JO',
  },
  {
    value: 192,
    label: 'remote.common.gjtGlobalCountry.country114',
    name: 'Kazakhstan',
    prefix: 'KZ',
  },
  {
    value: 210,
    label: 'remote.common.gjtGlobalCountry.country115',
    name: 'Kenya',
    prefix: 'KE',
  },
  {
    value: 197,
    label: 'remote.common.gjtGlobalCountry.country116',
    name: 'Kiribati',
    prefix: 'KI',
  },
  {
    value: 170,
    label: 'remote.common.gjtGlobalCountry.country117',
    name: "Korea (Democratic People's Republic of)",
    prefix: 'KP',
  },
  {
    value: 102,
    label: 'remote.common.gjtGlobalCountry.country118',
    name: 'Korea (Republic of)',
    prefix: 'KR',
  },
  {
    value: 127,
    label: 'remote.common.gjtGlobalCountry.country119',
    name: 'Kuwait',
    prefix: 'KW',
  },
  {
    value: 199,
    label: 'remote.common.gjtGlobalCountry.country120',
    name: 'Kyrgyzstan',
    prefix: 'KG',
  },
  {
    value: 214,
    label: 'remote.common.gjtGlobalCountry.country121',
    name: "Lao People's Democratic Republic",
    prefix: 'LA',
  },
  {
    value: 29,
    label: 'remote.common.gjtGlobalCountry.country122',
    name: 'Latvia',
    companyAddress: true,
    prefix: 'LV',
    isEuropeanUnion: true,
    icon: 'country_Latvia',
  },
  {
    value: 215,
    label: 'remote.common.gjtGlobalCountry.country123',
    name: 'Lebanon',
    prefix: 'LB',
  },
  {
    value: 213,
    label: 'remote.common.gjtGlobalCountry.country124',
    name: 'Lesotho',
    prefix: 'LS',
  },
  {
    value: 217,
    label: 'remote.common.gjtGlobalCountry.country125',
    name: 'Liberia',
    prefix: 'LR',
  },
  {
    value: 218,
    label: 'remote.common.gjtGlobalCountry.country126',
    name: 'Libya',
    prefix: 'LY',
  },
  {
    value: 219,
    label: 'remote.common.gjtGlobalCountry.country127',
    name: 'Liechtenstein',
    prefix: 'LI',
  },
  {
    value: 21,
    label: 'remote.common.gjtGlobalCountry.country128',
    name: 'Lithuania',
    companyAddress: true,
    prefix: 'LT',
    isEuropeanUnion: true
  },
  {
    value: 18,
    label: 'remote.common.gjtGlobalCountry.country129',
    name: 'Luxembourg',
    companyAddress: true,
    prefix: 'LU',
    isEuropeanUnion: true
  },
  {
    value: 122,
    label: 'remote.common.gjtGlobalCountry.country130',
    name: 'Macao',
    prefix: 'MO',
  },
  {
    value: 159,
    label: 'remote.common.gjtGlobalCountry.country131',
    name: 'Macedonia (the former Yugoslav Republic of)',
    prefix: 'MK',
  },
  {
    value: 224,
    label: 'remote.common.gjtGlobalCountry.country132',
    name: 'Madagascar',
    prefix: 'MG',
  },
  {
    value: 227,
    label: 'remote.common.gjtGlobalCountry.country133',
    name: 'Malawi',
    prefix: 'MW',
  },
  {
    value: 113,
    label: 'remote.common.gjtGlobalCountry.country134',
    name: 'Malaysia',
    prefix: 'MY',
  },
  {
    value: 225,
    label: 'remote.common.gjtGlobalCountry.country135',
    name: 'Maldives',
    prefix: 'MV',
  },
  {
    value: 228,
    label: 'remote.common.gjtGlobalCountry.country136',
    name: 'Mali',
    prefix: 'ML',
  },
  {
    value: 19,
    label: 'remote.common.gjtGlobalCountry.country137',
    name: 'Malta',
    companyAddress: true,
    prefix: 'MT',
    isEuropeanUnion: true
  },
  {
    value: 229,
    label: 'remote.common.gjtGlobalCountry.country138',
    name: 'Marshall Islands',
    prefix: 'MH',
  },
  {
    value: 429,
    label: 'remote.common.gjtGlobalCountry.country139',
    name: 'Martinique',
    prefix: 'MQ',
  },
  {
    value: 231,
    label: 'remote.common.gjtGlobalCountry.country140',
    name: 'Mauritania',
    prefix: 'MR',
  },
  {
    value: 230,
    label: 'remote.common.gjtGlobalCountry.country141',
    name: 'Mauritius',
    prefix: 'MU',
  },
  {
    value: 430,
    label: 'remote.common.gjtGlobalCountry.country142',
    name: 'Mayotte',
    prefix: 'YT',
  },
  {
    value: 34,
    label: 'remote.common.gjtGlobalCountry.country143',
    name: 'Mexico',
    prefix: 'MX',
    supportPurchase: true,
    icon: 'country_Mexico',
  },
  {
    value: 431,
    label: 'remote.common.gjtGlobalCountry.country144',
    name: 'Micronesia (Federated States of)',
    prefix: 'FM',
  },
  {
    value: 235,
    label: 'remote.common.gjtGlobalCountry.country145',
    name: 'Moldova (Republic of)',
    prefix: 'MD',
  },
  {
    value: 237,
    label: 'remote.common.gjtGlobalCountry.country146',
    name: 'Monaco',
    prefix: 'MC',
  },
  {
    value: 232,
    label: 'remote.common.gjtGlobalCountry.country147',
    name: 'Mongolia',
    prefix: 'MN',
  },
  {
    value: 195,
    label: 'remote.common.gjtGlobalCountry.country148',
    name: 'Montenegro',
    prefix: 'ME',
  },
  {
    value: 432,
    label: 'remote.common.gjtGlobalCountry.country149',
    name: 'Montserrat',
    prefix: 'MS',
  },
  {
    value: 236,
    label: 'remote.common.gjtGlobalCountry.country150',
    name: 'Morocco',
    prefix: 'MA',
  },
  {
    value: 238,
    label: 'remote.common.gjtGlobalCountry.country151',
    name: 'Mozambique',
    prefix: 'MZ',
  },
  {
    value: 234,
    label: 'remote.common.gjtGlobalCountry.country152',
    name: 'Myanmar',
    prefix: 'MM',
  },
  {
    value: 239,
    label: 'remote.common.gjtGlobalCountry.country153',
    name: 'Namibia',
    prefix: 'NA',
  },
  {
    value: 240,
    label: 'remote.common.gjtGlobalCountry.country154',
    name: 'Nauru',
    prefix: 'NR',
  },
  {
    value: 241,
    label: 'remote.common.gjtGlobalCountry.country155',
    name: 'Nepal',
    prefix: 'NP',
  },
  {
    value: 7,
    label: 'remote.common.gjtGlobalCountry.country156',
    name: 'Netherlands',
    companyAddress: true,
    supportPurchase: true,
    icon: 'country_Netherlands',
    prefix: 'NL',
    isEuropeanUnion: true
  },
  {
    value: 433,
    label: 'remote.common.gjtGlobalCountry.country157',
    name: 'New Caledonia',
    prefix: 'NC',
  },
  {
    value: 124,
    label: 'remote.common.gjtGlobalCountry.country158',
    name: 'New Zealand',
    prefix: 'NZ',
  },
  {
    value: 242,
    label: 'remote.common.gjtGlobalCountry.country159',
    name: 'Nicaragua',
    prefix: 'NI',
  },
  {
    value: 243,
    label: 'remote.common.gjtGlobalCountry.country160',
    name: 'Niger',
    prefix: 'NE',
  },
  {
    value: 133,
    label: 'remote.common.gjtGlobalCountry.country161',
    name: 'Nigeria',
    prefix: 'NG',
  },
  {
    value: 244,
    label: 'remote.common.gjtGlobalCountry.country162',
    name: 'Niue',
    prefix: 'NU',
  },
  {
    value: 434,
    label: 'remote.common.gjtGlobalCountry.country163',
    name: 'Norfolk Island',
    prefix: 'NF',
  },
  {
    value: 435,
    label: 'remote.common.gjtGlobalCountry.country164',
    name: 'Northern Mariana Islands',
    prefix: 'MP',
  },
  {
    value: 245,
    label: 'remote.common.gjtGlobalCountry.country165',
    name: 'Norway',
    prefix: 'NO',
  },
  {
    value: 141,
    label: 'remote.common.gjtGlobalCountry.country166',
    name: 'Oman',
    prefix: 'OM',
  },
  {
    value: 153,
    label: 'remote.common.gjtGlobalCountry.country167',
    name: 'Pakistan',
    prefix: 'PK',
  },
  {
    value: 436,
    label: 'remote.common.gjtGlobalCountry.country168',
    name: 'Palau',
    prefix: 'PW',
  },
  {
    value: 176,
    label: 'remote.common.gjtGlobalCountry.country169',
    name: 'Palestine, State of',
    prefix: 'PS',
  },
  {
    value: 156,
    label: 'remote.common.gjtGlobalCountry.country170',
    name: 'Panama',
    prefix: 'PA',
  },
  {
    value: 151,
    label: 'remote.common.gjtGlobalCountry.country171',
    name: 'Papua New Guinea',
    prefix: 'PG',
  },
  {
    value: 154,
    label: 'remote.common.gjtGlobalCountry.country172',
    name: 'Paraguay',
    prefix: 'PY',
  },
  {
    value: 162,
    label: 'remote.common.gjtGlobalCountry.country173',
    name: 'Peru',
    prefix: 'PE',
  },
  {
    value: 103,
    label: 'remote.common.gjtGlobalCountry.country174',
    name: 'Philippines',
    prefix: 'PH',
  },
  {
    value: 437,
    label: 'remote.common.gjtGlobalCountry.country175',
    name: 'Pitcairn',
    prefix: 'PN',
  },
  {
    value: 5,
    label: 'remote.common.gjtGlobalCountry.country176',
    name: 'Poland',
    icon: 'country_Poland',
    companyAddress: true,
    prefix: 'PL',
    isEuropeanUnion: true
  },
  {
    value: 20,
    label: 'remote.common.gjtGlobalCountry.country177',
    name: 'Portugal',
    companyAddress: true,
    prefix: 'PT',
    isEuropeanUnion: true,
    icon: 'country_Portugal',
  },
  {
    value: 438,
    label: 'remote.common.gjtGlobalCountry.country178',
    name: 'Puerto Rico',
    prefix: 'PR',
  },
  {
    value: 126,
    label: 'remote.common.gjtGlobalCountry.country179',
    name: 'Qatar',
    prefix: 'QA',
  },
  {
    value: 439,
    label: 'remote.common.gjtGlobalCountry.country180',
    name: 'Réunion',
    prefix: 'RE',
  },
  {
    value: 22,
    label: 'remote.common.gjtGlobalCountry.country181',
    name: 'Romania',
    companyAddress: true,
    prefix: 'RO',
    isEuropeanUnion: true
  },
  {
    value: 129,
    label: 'remote.common.gjtGlobalCountry.country182',
    name: 'Russian Federation',
    prefix: 'RU',
  },
  {
    value: 221,
    label: 'remote.common.gjtGlobalCountry.country183',
    name: 'Rwanda',
    prefix: 'RW',
  },
  {
    value: 440,
    label: 'remote.common.gjtGlobalCountry.country184',
    name: 'Saint Barthélemy',
    prefix: 'BL',
  },
  {
    value: 441,
    label: 'remote.common.gjtGlobalCountry.country185',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    prefix: 'SH',
  },
  {
    value: 256,
    label: 'remote.common.gjtGlobalCountry.country186',
    name: 'Saint Kitts and Nevis',
    prefix: 'KN',
  },
  {
    value: 257,
    label: 'remote.common.gjtGlobalCountry.country187',
    name: 'Saint Lucia',
    prefix: 'LC',
  },
  {
    value: 442,
    label: 'remote.common.gjtGlobalCountry.country188',
    name: 'Saint Martin (French part)',
    prefix: 'MF',
  },
  {
    value: 443,
    label: 'remote.common.gjtGlobalCountry.country189',
    name: 'Saint Pierre and Miquelon',
    prefix: 'PM',
  },
  {
    value: 259,
    label: 'remote.common.gjtGlobalCountry.country190',
    name: 'Saint Vincent and the Grenadines',
    prefix: 'VC',
  },
  {
    value: 249,
    label: 'remote.common.gjtGlobalCountry.country191',
    name: 'Samoa',
    prefix: 'WS',
  },
  {
    value: 258,
    label: 'remote.common.gjtGlobalCountry.country192',
    name: 'San Marino',
    prefix: 'SM',
  },
  {
    value: 255,
    label: 'remote.common.gjtGlobalCountry.country193',
    name: 'Sao Tome and Principe',
    prefix: 'ST',
  },
  {
    value: 11,
    label: 'remote.common.gjtGlobalCountry.country194',
    name: 'Saudi Arabia',
    prefix: 'SA',
    icon: 'country_SaudiArabia',
    supportPurchase: true
  },
  {
    value: 252,
    label: 'remote.common.gjtGlobalCountry.country195',
    name: 'Senegal',
    prefix: 'SN',
  },
  {
    value: 250,
    label: 'remote.common.gjtGlobalCountry.country196',
    name: 'Serbia',
    prefix: 'RS',
  },
  {
    value: 254,
    label: 'remote.common.gjtGlobalCountry.country197',
    name: 'Seychelles',
    prefix: 'SC',
  },
  {
    value: 251,
    label: 'remote.common.gjtGlobalCountry.country198',
    name: 'Sierra Leone',
    prefix: 'SL',
  },
  {
    value: 120,
    label: 'remote.common.gjtGlobalCountry.country199',
    name: 'Singapore',
    prefix: 'SG',
    icon: 'country_Singapore',
  },
  {
    value: 444,
    label: 'remote.common.gjtGlobalCountry.country200',
    name: 'Sint Maarten (Dutch part)',
    prefix: 'SX',
  },
  {
    value: 23,
    label: 'remote.common.gjtGlobalCountry.country201',
    name: 'Slovakia',
    companyAddress: true,
    prefix: 'SK',
    isEuropeanUnion: true
  },
  {
    value: 24,
    label: 'remote.common.gjtGlobalCountry.country202',
    name: 'Slovenia',
    companyAddress: true,
    prefix: 'SI',
    isEuropeanUnion: true,
    icon: 'country_Slovenia',
  },
  {
    value: 267,
    label: 'remote.common.gjtGlobalCountry.country203',
    name: 'Solomon Islands',
    prefix: 'SB',
  },
  {
    value: 268,
    label: 'remote.common.gjtGlobalCountry.country204',
    name: 'Somalia',
    prefix: 'SO',
  },
  {
    value: 135,
    label: 'remote.common.gjtGlobalCountry.country205',
    name: 'South Africa',
    prefix: 'ZA',
  },
  {
    value: 445,
    label: 'remote.common.gjtGlobalCountry.country206',
    name: 'South Georgia and the South Sandwich Islands',
    prefix: 'GS',
  },
  {
    value: 265,
    label: 'remote.common.gjtGlobalCountry.country207',
    name: 'South Sudan',
    prefix: 'SS',
  },
  {
    value: 446,
    label: 'remote.common.gjtGlobalCountry.country208',
    name: 'American Samoa',
    prefix: 'AS',
  },
  {
    value: 260,
    label: 'remote.common.gjtGlobalCountry.country209',
    name: 'Sri Lanka',
    prefix: 'LK',
  },
  {
    value: 264,
    label: 'remote.common.gjtGlobalCountry.country210',
    name: 'Sudan',
    prefix: 'SD',
  },
  {
    value: 266,
    label: 'remote.common.gjtGlobalCountry.country211',
    name: 'Suriname',
    prefix: 'SR',
  },
  {
    value: 447,
    label: 'remote.common.gjtGlobalCountry.country212',
    name: 'Svalbard and Jan Mayen',
    prefix: 'SJ',
  },
  {
    value: 263,
    label: 'remote.common.gjtGlobalCountry.country213',
    name: 'Swaziland',
    prefix: 'SZ',
  },
  {
    value: 10,
    label: 'remote.common.gjtGlobalCountry.country214',
    name: 'Sweden',
    companyAddress: true,
    prefix: 'SE',
    isEuropeanUnion: true,
    icon: 'country_Sweden',
  },
  {
    value: 32,
    label: 'remote.common.gjtGlobalCountry.country215',
    name: 'Switzerland',
    prefix: 'CH',
    icon: 'country_Switzerland',
  },
  {
    value: 286,
    label: 'remote.common.gjtGlobalCountry.country216',
    name: 'Syrian Arab Republic',
    prefix: 'SY',
  },
  {
    value: 123,
    label: 'remote.common.gjtGlobalCountry.country217',
    name: 'Taiwan, Province of China',
    prefix: 'TW',
  },
  {
    value: 269,
    label: 'remote.common.gjtGlobalCountry.country218',
    name: 'Tajikistan',
    prefix: 'TJ',
  },
  {
    value: 270,
    label: 'remote.common.gjtGlobalCountry.country219',
    name: 'Tanzania, United Republic of',
    prefix: 'TZ',
  },
  {
    value: 116,
    label: 'remote.common.gjtGlobalCountry.country220',
    name: 'Thailand',
    prefix: 'TH',
  },
  {
    value: 448,
    label: 'remote.common.gjtGlobalCountry.country221',
    name: 'Timor-Leste',
    prefix: 'TL',
  },
  {
    value: 174,
    label: 'remote.common.gjtGlobalCountry.country222',
    name: 'Togo',
    prefix: 'TG',
  },
  {
    value: 449,
    label: 'remote.common.gjtGlobalCountry.country223',
    name: 'Tokelau',
    prefix: 'TK',
  },
  {
    value: 271,
    label: 'remote.common.gjtGlobalCountry.country224',
    name: 'Tonga',
    prefix: 'TO',
  },
  {
    value: 272,
    label: 'remote.common.gjtGlobalCountry.country225',
    name: 'Trinidad and Tobago',
    prefix: 'TT',
  },
  {
    value: 273,
    label: 'remote.common.gjtGlobalCountry.country226',
    name: 'Tunisia',
    prefix: 'TN',
  },
  {
    value: 33,
    label: 'remote.common.gjtGlobalCountry.country227',
    name: 'Turkey',
    prefix: 'TR',
    icon: 'country_Istanbul',
  },
  {
    value: 275,
    label: 'remote.common.gjtGlobalCountry.country228',
    name: 'Turkmenistan',
    prefix: 'TM',
  },
  {
    value: 451,
    label: 'remote.common.gjtGlobalCountry.country229',
    name: 'Turks and Caicos Islands',
    prefix: 'TC',
  },
  {
    value: 274,
    label: 'remote.common.gjtGlobalCountry.country230',
    name: 'Tuvalu',
    prefix: 'TV',
  },
  {
    value: 280,
    label: 'remote.common.gjtGlobalCountry.country231',
    name: 'Uganda',
    prefix: 'UG',
  },
  {
    value: 281,
    label: 'remote.common.gjtGlobalCountry.country232',
    name: 'Ukraine',
    prefix: 'UA',
  },
  {
    value: 12,
    label: 'remote.common.gjtGlobalCountry.country233',
    name: 'United Arab Emirates',
    prefix: 'AE',
    icon: 'country_TheUnitedArabEmirates',
    supportPurchase: true
  },
  {
    value: 139,
    label: 'remote.common.gjtGlobalCountry.country234',
    name: 'Afghanistan',
    prefix: 'AF',
  },
  {
    value: 453,
    label: 'remote.common.gjtGlobalCountry.country235',
    name: 'United States Minor Outlying Islands',
    prefix: 'UM',
  },
  {
    value: 101,
    label: 'remote.common.gjtGlobalCountry.country236',
    name: 'United States of America',
    companyAddress: true,
    icon: 'country_America',
    prefix: 'US',
  },
  {
    value: 282,
    label: 'remote.common.gjtGlobalCountry.country237',
    name: 'Uruguay',
    prefix: 'UY',
  },
  {
    value: 283,
    label: 'remote.common.gjtGlobalCountry.country238',
    name: 'Uzbekistan',
    prefix: 'UZ',
  },
  {
    value: 276,
    label: 'remote.common.gjtGlobalCountry.country239',
    name: 'Vanuatu',
    prefix: 'VU',
  },
  {
    value: 278,
    label: 'remote.common.gjtGlobalCountry.country240',
    name: 'Venezuela (Bolivarian Republic of)',
    prefix: 'VE',
  },
  {
    value: 117,
    label: 'remote.common.gjtGlobalCountry.country241',
    name: 'Viet Nam',
    prefix: 'VN',
  },
  {
    value: 454,
    label: 'remote.common.gjtGlobalCountry.country242',
    name: 'Virgin Islands (British)',
    prefix: 'VG',
    icon: 'a-country_VirginIslandsBritish',
  },
  {
    value: 455,
    label: 'remote.common.gjtGlobalCountry.country243',
    name: 'Virgin Islands (U.S.)',
    prefix: 'VI',
  },
  {
    value: 456,
    label: 'remote.common.gjtGlobalCountry.country244',
    name: 'Wallis and Futuna',
    prefix: 'WF',
  },
  {
    value: 457,
    label: 'remote.common.gjtGlobalCountry.country245',
    name: 'Western Sahara',
    prefix: 'EH',
  },
  {
    value: 289,
    label: 'remote.common.gjtGlobalCountry.country246',
    name: 'Yemen',
    prefix: 'YE',
  },
  {
    value: 294,
    label: 'remote.common.gjtGlobalCountry.country247',
    name: 'Zambia',
    prefix: 'ZM',
  },
  {
    value: 205,
    label: 'remote.common.gjtGlobalCountry.country248',
    name: 'Zimbabwe',
    prefix: 'ZW',
  },
  {
    value: 99,
    label: 'remote.common.gjtGlobalCountry.country249',
    name: 'European Union',
    icon: 'country_EuropeanUnion',
    prefix: '',
  },
  {
    value: 30,
    label: 'remote.common.gjtGlobalCountry.country250',
    name: 'Northern Ireland',
    icon: 'country_NorthernIreland',
  }
]

//vat 税号国家
// 加那利群岛（西班牙）仅用于 VATAI 欧洲站开票场景，不加入全局国家列表。
export const CANARY_ISLANDS_COUNTRY_CODE = 458

export const canaryIslandsInvoiceCountry = Object.freeze({
  value: CANARY_ISLANDS_COUNTRY_CODE,
  label: 'remote.common.gjtGlobalCountry.country251',
  name: 'Canary Islands (Spain)',
  icon: '',
  prefix: '',
  isEuropeanUnion: false
})

/**
 * 获取当前平台可用的开票国家列表。
 * @param {string|number} platform 平台编码
 * @returns {Array}
 */
export function getGjtInvoiceCountries(platform) {
  return String(platform) === '16'
    ? [...gjtGlobalCountry, canaryIslandsInvoiceCountry]
    : gjtGlobalCountry
}

/**
 * 判断切换国家时是否需要清空历史税号。
 * @param {string|number} platform 平台编码
 * @param {string|number} country 国家编码
 * @returns {boolean}
 */
export function shouldClearCanaryIslandsVatId(platform, country) {
  return String(platform) === '16' && Number(country) === CANARY_ISLANDS_COUNTRY_CODE
}

export const VATCountryEnum = [
  {
    value: 0,
    label: 'remote.common.gjtGlobalCountry.country0',
    name: 'United Kingdom',
    icon: 'country_UK',
    taxNumberPrefix: 'GB',
    taxNumberRegular: '^[0-9]{9}$',
    errText: 'remote.common.VATCountry.regularErrorText.country0',
  },
  {
    value: 1,
    label: 'remote.common.gjtGlobalCountry.country1',
    name: 'France',
    icon: 'country_France',
    taxNumberPrefix: 'FR',
    taxNumberRegular: '^[0-9a-zA-Z]{11}$',
    errText: 'remote.common.VATCountry.regularErrorText.country1',
  },
  {
    value: 2,
    label: 'remote.common.gjtGlobalCountry.country2',
    name: 'Germany',
    icon: 'country_Germany',
    taxNumberPrefix: 'DE',
    taxNumberRegular: '^[0-9]{9}$',
    errText: 'remote.common.VATCountry.regularErrorText.country2',
  },
  {
    value: 3,
    label: 'remote.common.gjtGlobalCountry.country3',
    name: 'Italy',
    icon: 'country_Italy',
    taxNumberPrefix: 'IT',
    taxNumberRegular: '^[0-9]{11}$',
    errText: 'remote.common.VATCountry.regularErrorText.country3',
  },
  {
    value: 4,
    label: 'remote.common.gjtGlobalCountry.country4',
    name: 'Spain',
    icon: 'country_Spain',
    taxNumberPrefix: 'ES',
    taxNumberRegular: '^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{9}$',
    errText: 'remote.common.VATCountry.regularErrorText.country4',
  },
  {
    value: 8,
    label: 'remote.common.gjtGlobalCountry.country14',
    name: 'Austria',
    icon: 'country_Austria',
    taxNumberPrefix: 'AT',
    taxNumberRegular: '^U[0-9]{8}$',
    errText: 'remote.common.VATCountry.regularErrorText.country8',
    supportPurchase: true
  },
  {
    value: 9,
    label: 'remote.common.gjtGlobalCountry.country21',
    name: 'Belgium',
    icon: 'country_Belgium',
    taxNumberPrefix: 'BE',
    taxNumberRegular: '^\\d{9,10}$',
    errText: 'remote.common.VATCountry.regularErrorText.country9',
    supportPurchase: true
  },
  {
    value: 25,
    label: 'remote.common.gjtGlobalCountry.country34',
    name: 'Bulgaria',
    icon: 'country_Bulgaria',
    taxNumberPrefix: 'BG',
    taxNumberRegular: '^\\d{9,10}$',
    errText: 'remote.common.VATCountry.regularErrorText.country11',
  },
  {
    value: 27,
    label: 'remote.common.gjtGlobalCountry.country55',
    name: 'Croatia',
    icon: 'country_Croatia',
    taxNumberPrefix: 'HR',
    taxNumberRegular: '^[0-9]{11}$',
    errText: 'remote.common.VATCountry.regularErrorText.country28',
  },
  {
    value: 26,
    label: 'remote.common.gjtGlobalCountry.country58',
    name: 'Cyprus',
    icon: 'country_Cyprus',
    taxNumberPrefix: 'CY',
    taxNumberRegular: '^[a-z|A-Z|0-9]{9}$',
    errText: 'remote.common.VATCountry.regularErrorText.country12',
  },
  {
    value: 6,
    label: 'remote.common.gjtGlobalCountry.country59',
    name: 'Czech Republic',
    icon: 'country_CzechRepublic',
    taxNumberPrefix: 'CZ',
    taxNumberRegular: '^[A-Za-z0-9]{8,10}$',
    errText: 'remote.common.VATCountry.regularErrorText.country7',
    supportPurchase: true
  },
  {
    value: 14,
    label: 'remote.common.gjtGlobalCountry.country60',
    name: 'Denmark',
    icon: 'country_Denmark',
    taxNumberPrefix: 'DK',
    taxNumberRegular: '^[0-9]{8}$',
    errText: 'remote.common.VATCountry.regularErrorText.country13',
  },
  {
    value: 28,
    label: 'remote.common.gjtGlobalCountry.country69',
    name: 'Estonia',
    icon: 'country_Estonia',
    taxNumberPrefix: 'EE',
    taxNumberRegular: '^[0-9]{9}$',
    errText: 'remote.common.VATCountry.regularErrorText.country23',
  },
  {
    value: 13,
    label: 'remote.common.gjtGlobalCountry.country74',
    name: 'Finland',
    icon: 'country_Finland',
    taxNumberPrefix: 'FI',
    taxNumberRegular: '^[0-9]{8}$',
    errText: 'remote.common.VATCountry.regularErrorText.country19',
  },
  {
    value: 15,
    label: 'remote.common.gjtGlobalCountry.country85',
    name: 'Greece',
    icon: 'country_Greece',
    taxNumberPrefix: 'EL',
    taxNumberRegular: '^[0-9]{9}$',
    errText: 'remote.common.VATCountry.regularErrorText.country24',
  },
  {
    value: 16,
    label: 'remote.common.gjtGlobalCountry.country100',
    name: 'Hungary',
    icon: 'country_Hungary',
    taxNumberPrefix: 'HU',
    taxNumberRegular: '^[0-9]{8}$',
    errText: 'remote.common.VATCountry.regularErrorText.country20',
  },
  {
    value: 17,
    label: 'remote.common.gjtGlobalCountry.country106',
    name: 'Ireland',
    icon: 'country_Ireland',
    taxNumberPrefix: 'IE',
    taxNumberRegular: '^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,9}$',
    errText: 'remote.common.VATCountry.regularErrorText.country14',
  },
  {
    value: 100,
    label: 'remote.common.gjtGlobalCountry.country111',
    name: 'Japan',
  },
  {
    value: 29,
    label: 'remote.common.gjtGlobalCountry.country122',
    name: 'Latvia',
    icon: 'country_Latvia',
    taxNumberPrefix: 'LV',
    taxNumberRegular: '^\\d{9}(\\d{2})?$',
    errText: 'remote.common.VATCountry.regularErrorText.country18',
  },
  {
    value: 21,
    label: 'remote.common.gjtGlobalCountry.country128',
    name: 'Lithuania',
    icon: 'country_Lithuania',
    taxNumberPrefix: 'LT',
    taxNumberRegular: '^\\d{9}(\\d{3})?$',
    errText: 'remote.common.VATCountry.regularErrorText.country26',
  },
  {
    value: 18,
    label: 'remote.common.gjtGlobalCountry.country129',
    name: 'Luxembourg',
    icon: 'country_Luxembourg',
    taxNumberPrefix: 'LU',
    taxNumberRegular: '^[0-9]{8}$',
    errText: 'remote.common.VATCountry.regularErrorText.country25',
  },
  {
    value: 19,
    label: 'remote.common.gjtGlobalCountry.country137',
    name: 'Malta',
    icon: 'country_Malta',
    taxNumberPrefix: 'MT',
    taxNumberRegular: '^[0-9]{8}$',
    errText: 'remote.common.VATCountry.regularErrorText.country21',
  },
  {
    value: 34,
    label: 'remote.common.gjtGlobalCountry.country143',
    name: 'Mexico',
    icon: 'country_Mexico',
  },
  {
    value: 7,
    label: 'remote.common.gjtGlobalCountry.country156',
    name: 'Netherlands',
    icon: 'country_Netherlands',
    taxNumberPrefix: 'NL',
    taxNumberRegular: '^[0-9a-zA-Z]{12}$',
    errText: 'remote.common.VATCountry.regularErrorText.country6',
  },
  {
    value: 5,
    label: 'remote.common.gjtGlobalCountry.country176',
    name: 'Poland',
    icon: 'country_Poland',
    taxNumberPrefix: 'PL',
    taxNumberRegular: '^[0-9]{10}$',
    errText: 'remote.common.VATCountry.regularErrorText.country5',
    supportPurchase: true
  },
  {
    value: 20,
    label: 'remote.common.gjtGlobalCountry.country177',
    name: 'Portugal',
    icon: 'country_Portugal',
    taxNumberPrefix: 'PT',
    taxNumberRegular: '^[0-9]{9}$',
    errText: 'remote.common.VATCountry.regularErrorText.country16',
  },
  {
    value: 22,
    label: 'remote.common.gjtGlobalCountry.country181',
    name: 'Romania',
    icon: 'country_Romania',
    taxNumberPrefix: 'RO',
    taxNumberRegular: '^\\d{2,10}$',
    errText: 'remote.common.VATCountry.regularErrorText.country22',
  },
  {
    value: 11,
    label: 'remote.common.gjtGlobalCountry.country194',
    name: 'Saudi Arabia',
    icon: 'country_SaudiArabia',
  },
  {
    value: 23,
    label: 'remote.common.gjtGlobalCountry.country201',
    name: 'Slovakia',
    icon: 'country_Slovakia',
    taxNumberPrefix: 'SK',
    taxNumberRegular: '^\\d{9,10}$',
    errText: 'remote.common.VATCountry.regularErrorText.country17',
  },
  {
    value: 24,
    label: 'remote.common.gjtGlobalCountry.country202',
    name: 'Slovenia',
    icon: 'country_Slovenia',
    taxNumberPrefix: 'SI',
    taxNumberRegular: '^[0-9]{8}$',
    errText: 'remote.common.VATCountry.regularErrorText.country27',
  },
  {
    value: 10,
    label: 'remote.common.gjtGlobalCountry.country214',
    name: 'Sweden',
    icon: 'country_Sweden',
    taxNumberPrefix: 'SE',
    taxNumberRegular: '^[0-9]{12}$',
    errText: 'remote.common.VATCountry.regularErrorText.country10',
  },
  {
    value: 32,
    taxNumberPrefix: 'CH',
    label: 'remote.common.gjtGlobalCountry.country215',
    name: 'Switzerland',
    icon: 'country_Switzerland',
  },
  {
    value: 12,
    label: 'remote.common.gjtGlobalCountry.country233',
    name: 'United Arab Emirates',
    icon: 'country_TheUnitedArabEmirates',
  },
  {
    value: 99,
    label: 'remote.common.gjtGlobalCountry.country249',
    name: 'European Union',
    icon: 'country_EuropeanUnion',
  },
  {
    value: 30,
    label: 'remote.common.gjtGlobalCountry.country250',
    name: 'Northern Ireland',
    icon: 'a-country_NorthernIreland',
    taxNumberRegular: '^(?:\\d{5}|\\d{9}|\\d{12})$',
    errText: 'remote.common.VATCountry.regularErrorText.country15',
  }
]



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/gjtGlobalCountry.js